exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collage-banner {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  max-height: 274px;\n  overflow: hidden; }\n  @media screen and (min-width: 992px) {\n    .collage-banner {\n      max-height: 548px; } }\n  @supports ((display: -ms-grid) or (display: grid)) {\n    .collage-banner {\n      display: -ms-grid;\n      display: grid;\n      -ms-grid-columns: 1fr 1fr 1fr 1fr;\n          grid-template-columns: 1fr 1fr 1fr 1fr;\n      max-height: 100%; }\n      @media screen and (min-width: 992px) {\n        .collage-banner {\n          max-height: 100%; } } }\n  .collage-banner__image {\n    overflow: hidden;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 0 25%;\n            flex: 1 0 25%;\n    -o-object-fit: cover;\n       object-fit: cover;\n    height: 274px;\n    width: 100%;\n    max-width: 100%;\n    min-width: 100%;\n    min-height: 274px;\n    max-height: 274px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/resort-collage-banner/resort-collage-banner.component.scss
// module id = ../../../../../src/app/shared/resort-collage-banner/resort-collage-banner.component.scss
// module chunks = main